// extracted by mini-css-extract-plugin
module.exports = {"tokenizerForm":"CreditCardForm_tokenizerForm__34tVs","cardComponentBox":"CreditCardForm_cardComponentBox__i0Txo","submitCardButton":"CreditCardForm_submitCardButton__EEZeJ"};